import { render, staticRenderFns } from "./AddSchedule.vue?vue&type=template&id=0b31d996"
import script from "./AddSchedule.vue?vue&type=script&lang=js"
export * from "./AddSchedule.vue?vue&type=script&lang=js"
import style0 from "./AddSchedule.vue?vue&type=style&index=0&id=0b31d996&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b31d996')) {
      api.createRecord('0b31d996', component.options)
    } else {
      api.reload('0b31d996', component.options)
    }
    module.hot.accept("./AddSchedule.vue?vue&type=template&id=0b31d996", function () {
      api.rerender('0b31d996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/price/AddSchedule.vue"
export default component.exports